/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import {SemiBoldText} from 'components/Text';
import {Breakpoints} from "../../constants/Breakpoints";

const Wrapper = styled.div`
  position: relative;
  margin-top: 2rem;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 40px; 
  background-color: ${Colors.GRAY[10]};
  background-color-primary: ${Colors.PRIMARY};
  background-color-test: orange;
  z-index: 1;

  @media screen and (min-width: ${Breakpoints.sm}) {
    position: fixed;
    margin-top: unset;
    z-index: 1000;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  // max-width: 945px;
  // margin: 0 auto;
  padding: 0px 20px 0px 20px;
`;

const Logo = styled.img`
  max-width: 120px;
`;

const Website = styled(SemiBoldText)`
  color: ${Colors.BLACK};
  font-size: 16px;
  margin-left: 10vw;
`;

export { Wrapper, Container, Logo, Website };
